import React, { useEffect, useCallback, useMemo, useState } from "react";
import { Form, Row, Col, Button, Spinner, Modal } from 'react-bootstrap';
import config from 'react-global-configuration';
import AWS from 'aws-sdk';
import axios from 'axios';
import toastr from "toastr";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AG_GRID_LOCALE_PT_BR } from "../../shared/localeText";
import HeaderComponent from '../../components/header';
import NewReport from './newReport';
import { cnpjMask, cpfMask } from '../../shared/mask';

function ListReports(params) {

    const [gridApi, setGridApi] = useState();
    const [rowData, setRowData] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [load, setLoad] = useState(false);
    const [dataSelected, setDataSelected] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [toogleCopyIcon, setToogleCopyIcon] = useState(false);

    const navigate = useNavigate();

    const dateFormat = (param) => new Date(param).toLocaleDateString("pt-br") + " " + new Date(param).toLocaleTimeString("pt-br");
    const currencyFormat = (param) => param.value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    const documentFormat = (param) => param && param.length === 14 ? cnpjMask(param.toString()) : cpfMask(param.toString());

    const containerStyle = useMemo(() => ({ width: "100%", height: "calc(100vh - 360px)" }), []);
    const gridStyle = useMemo(() => ({ height: "calc(100vh - 360px)", width: "100%" }), []);

    const statusColor = {
        started: 'green',
        created: 'black',
        error: 'red'
    }

    const statusText = {
        started: 'Processando',
        created: 'Criado',
        error: 'Erro'
    }


    const filterParams = {
        filterOptions: ['contains', 'notContains', 'equals', 'notEqual'],
    }

    const [columnDefs, setColumnDefs] = useState([
        // set filters
        {
            headerName: "Nome",
            field: "razao_social",
            filter: true,
            filterParams: filterParams,
            minWidth: 250,
            cellRenderer: params => {
                return params.value && <><span>{params.value}</span> <a onClick={(e) => handleCopyToClipboard(e, params.value)}><i className="bi bi-copy" style={{ position: 'absolute', right: 0, color: 'green', cursor: 'pointer' }} title="clique para copiar o nome"></i></a></>;
            }
        },
        {
            headerName: "Número do Documento",
            field: "doc_number",
            filter: true,
            filterParams: filterParams,
            minWidth: 200,
            // valueFormatter: documentFormat,
            cellRenderer: params => {
                return params.value && <><span>{documentFormat(params.value)}</span> <a onClick={(e) => handleCopyToClipboard(e, documentFormat(params.value))}><i className="bi bi-copy" style={{ position: 'absolute', right: 0, color: 'green', cursor: 'pointer' }} title="clique para copiar o número"></i></a></>;
            }
        },
        {
            headerName: "Data",
            field: "data_relatorio",
            filter: true,
            filterParams: filterParams,
            // valueFormatter: dateFormat,
            cellRenderer: params => {
                return params.value && <><span>{dateFormat(params.value)}</span> <a onClick={(e) => handleCopyToClipboard(e, dateFormat(params.value))}><i className="bi bi-copy" style={{ position: 'absolute', right: 0, color: 'green', cursor: 'pointer' }} title="clique para copiar a data"></i></a></>;
            }
        },
        {
            headerName: "Score",
            field: "esg_score",
            children: [
                {
                    headerName: "iESGscan",
                    field: "esg_score.iESGscan",
                    minWidth: 70,
                    filter: true,
                    filterParams: filterParams,
                },
                {
                    headerName: "Social",
                    field: "esg_score.Social",
                    minWidth: 70,
                    filter: true,
                    filterParams: filterParams,
                },
                {
                    headerName: "Ambiental",
                    field: "esg_score.Ambiental",
                    minWidth: 70,
                    filter: true,
                    filterParams: filterParams,
                },
                {
                    headerName: "Governança",
                    field: "esg_score.Governança",
                    minWidth: 70,
                    filter: true,
                    filterParams: filterParams,
                },
            ],
        },
        {
            headerName: "Status",
            field: "status_report",
            filter: true,
            filterParams: filterParams,
            minWidth: 80,
            cellRenderer: param => {
                return <span style={{ color: statusColor[param.value] }}>{statusText[param.value]}</span>
            }
        },
        {
            headerName: "PDF",
            field: "doc_number",
            filter: true,
            filterParams: filterParams,
            minWidth: 100,
            valueGetter: p => p.data.data_relatorio + ',' + p.data.doc_number + ',' + p.data.status_report,
            cellRenderer: params => {
                return params.value.split(',')[2] === 'created' && <button type="button" onClick={(e) => handleDownloadPDF(e, params.value)}> <i className="bi bi-file-earmark-pdf-fill"></i> Download</button>;
            }
        },
    ]);

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 110,
        };
    }, []);

    useEffect(() => {
        document.body.className = '';
    }, []);

    let targetPDF = false;

    const onGridReady = useCallback((param) => {
        targetPDF = false;
        setGridApi(param.api);
        setGridData(true, param.api);
        //param.api.setGridOption("rowData", []);
    }, []);


    const onSelectionChanged = useCallback((param) => {
        if (!targetPDF) {
            const selectedRow = param.api.getSelectedRows();
            if (selectedRow && selectedRow.length > 0 && (selectedRow[0].status_report === 'started' || selectedRow[0].status_report === 'error')) {
                toastr.error(`O relatório com status "${statusText[selectedRow[0].status_report]}" não pode ser visualizado`);
                return;
            }
            if (selectedRow && selectedRow.length > 0) {
                const startDate = document.getElementById('startDate').value;
                const endDate = document.getElementById('endDate').value;
                if (isValidDate(startDate) && isValidDate(endDate)) {
                    sessionStorage.setItem('filtroGridScore', `${startDate},${endDate},${param.api.paginationGetCurrentPage()}`);
                    sessionStorage.setItem('headerFiltroGrid', JSON.stringify(param.api.getFilterModel()))
                }
                navigate('/report', { state: selectedRow });
            }
        } else {
            param.api.deselectAll();
        }
        targetPDF = false;
    }, []);

    const gridOptions = {
        defaultColDef: defaultColDef,
        columnDefs: columnDefs,
        suppressContextMenu: true,
        suppressCellFocus: true,
        pagination: true,
        paginationAutoPageSize: true,
        paginateChildRows: true,
        rowSelection: "single",
        localeText: AG_GRID_LOCALE_PT_BR,
        enableCellTextSelection: false,
        onGridReady: onGridReady,
        onSelectionChanged: onSelectionChanged
    };


    const isValidDate = (dateString) => {
        var validDate = true;

        // First check for the pattern
        if (!/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(dateString)) {
            return false;
        }

        // Parse the date parts to integers
        var parts = dateString.split("-");
        var day = parseInt(parts[2], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[0], 10);

        if (isNaN(day) || isNaN(month) || isNaN(year)) {
            return false;
        }

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month < 1 || month > 12) {
            return false;
        }

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
            monthLength[1] = 29;
        }

        // Check the range of the day
        if (!(day > 0 && day <= monthLength[month - 1])) {
            return false;
        }

        return true;

    };

    const subtractDate = function (date = null, amount) {
        var tmpDate = date ? new Date(date) : new Date();
        tmpDate.setDate(tmpDate.getDate() - amount)
        return tmpDate;
    };

    const setGridData = async (init, grid = null) => {
        let startDate = document.getElementById('startDate').value;
        let endDate = document.getElementById('endDate').value;

        if (init) {
            if (sessionStorage.getItem('filtroGridScore')) {
                startDate = sessionStorage.getItem('filtroGridScore').split(',')[0];
                endDate = sessionStorage.getItem('filtroGridScore').split(',')[1];
            } else {
                startDate = subtractDate(null, 30).toISOString().split('T')[0];
                endDate = new Date().toISOString().split('T')[0];
            }

            document.getElementById('startDate').value = startDate;
            document.getElementById('endDate').value = endDate;
        }

        grid = grid ? grid : gridApi;
        if (isValidDate(startDate) && isValidDate(endDate)) {
            setLoad(true);
            try {
                const url = config.get('urlbase') + '/reports/v2/list-reports?contract_id=' + JSON.parse(localStorage.getItem('userInfos')).data.contract_id + '&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&start_date=' + startDate + '&end_date=' + endDate;
                const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token };
                const data = (await axios.get(url, { headers })).data;
                grid.setGridOption("rowData", data.Item.Reports);
                if (init && sessionStorage.getItem('filtroGridScore')) {
                    grid.paginationGoToPage(parseInt(sessionStorage.getItem('filtroGridScore').split(',')[2]));
                    if (sessionStorage.getItem('headerFiltroGrid')) {
                        const obj = JSON.parse(sessionStorage.getItem('headerFiltroGrid'));
                        grid.setFilterModel(obj);
                    }
                    sessionStorage.removeItem('filtroGridScore');
                    sessionStorage.removeItem('headerFiltroGrid');
                } else {
                    grid.paginationGoToPage(0);
                }
                setLoad(false);
            } catch (error) {
                setLoad(false);
                console.log(error);
                toastr.error('Erro ao filtrar o relatório');
            }

        } else {
            toastr.error('Data inválida');
        }
    }

    const handleCopyToClipboard = (e, param) => {
        e.stopPropagation();
        targetPDF = true;
        setToogleCopyIcon(true);
        navigator.clipboard.writeText(param).then(() => {  });
        toastr.success('Nome copiado com sucesso');
    }

    


    const handleDownloadPDF = async (e, param) => {
        e.stopPropagation();
        targetPDF = true;
        const values = param.split(',');
        setLoad(true);
        try {
            const url = config.get('urlbase') + '/reports/v2/download-report?formato=pdf&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&data_relatorio=' + values[0] + '&documento=' + values[1];
            const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token };
            const data = (await axios.get(url, { headers })).data.Item;
            window.open(data.Url, '_blank');
            setLoad(false);
        } catch (error) {
            setLoad(false);
            console.log(error);
            toastr.error('Erro ao solicitar o download do relatório');
        }

    }

    const handleNewReport = () => {
        setShowModal(true)
    }

    const handleCloseModal = () => {
        setShowModal(false)
    }

    const handleUpdateList = () => {
        setShowModal(false)
        const startDate = document.getElementById('startDate').value;
        const endDate = document.getElementById('endDate').value;
        const grid = gridApi;
        if (grid && isValidDate(startDate) && isValidDate(endDate)) {
            setGridData(false);
        }
    }

    return (
        <>
            <HeaderComponent />
            <section className='panel-default'>
                
                <h5 className="mb-4">Lista de Relatórios de Riscos ESG</h5>
                <Form className='mb-4'>
                    <Col>
                        <Row className="align-items-center">
                            <Col md={6}>
                                <Row className="align-items-center">
                                    <Form.Group as={Col}>
                                        <Form.Label>Data de Início:*</Form.Label>
                                        <Form.Control
                                            type="date"
                                            id="startDate"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Data de Fim:*</Form.Label>
                                        <Form.Control
                                            type="date"
                                            id="endDate"
                                        />
                                    </Form.Group>
                                    <Col>
                                        {!load ?
                                            <>
                                                <Button variant="filter" className="mt-4 me-3 float--l" onClick={() => setGridData(false)}>
                                                    Filtrar
                                                </Button>
                                                {!load && <a href="javascript:;" className="mt-4 display--block fs-3" onClick={() => setGridData(false)} title="Recarregar"><i className="bi bi-arrow-repeat"></i></a>}
                                            </>
                                            :
                                            <Spinner animation="border" className="mt-4" variant="success" />
                                        }
                                    </Col>
                                    <Col>

                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6}>
                                <a className='float--r bt-new-report' href='javascript:void(0);' onClick={handleNewReport}>Novo Relatório <img className='ms-3' width='11%' src={process.env.PUBLIC_URL + '/static/imagens/bt-mais.png'} alt='Novo Relatório' /></a>
                            </Col>
                        </Row>
                    </Col>
                </Form>
                <div style={containerStyle}>
                    <div style={gridStyle} className={"ag-theme-quartz"}>
                        <AgGridReact {...gridOptions} />
                    </div>
                </div>
            </section>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <NewReport onClose={handleCloseModal} onUpdate={handleUpdateList}></NewReport>
            </Modal>
        </>
    );
};

export default ListReports;
